import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 50);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = isHomePage
    ? [
        { name: "Home", href: "#home", isAnchor: true },
        { name: "About", href: "/about", isAnchor: false },
        { name: "Services", href: "#services", isAnchor: true },
        { name: "Case Studies", href: "/case-studies", isAnchor: false },
        { name: "Contact", href: "/contact", isAnchor: false },
      ]
    : [
        { name: "Home", href: "/", isAnchor: false },
        { name: "About", href: "/about", isAnchor: false },
        { name: "Services", href: "/#services", isAnchor: false },
        { name: "Case Studies", href: "/case-studies", isAnchor: false },
        { name: "Contact", href: "/contact", isAnchor: false },
      ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 px-6 md:px-12 lg:px-20 py-4 animate-fade-in">
      <div
        className="absolute inset-0 backdrop-blur-xl border-b transition-all duration-500"
        style={{
          backgroundColor: isScrolled ? "hsla(224, 35%, 6%, 0.85)" : "transparent",
          borderColor: isScrolled ? "hsla(40, 35%, 94%, 0.06)" : "transparent",
        }}
      />

      <div className="max-w-7xl mx-auto flex items-center justify-between relative z-10">
        <div className="transition-transform duration-300 hover:scale-[1.02]">
          <Link to="/" aria-label="Zaibify Digital Solutions home" className="inline-flex items-center">
            <BrandLogo imgClassName="h-10 w-auto md:h-12" priority />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            link.isAnchor ? (
              <a
                key={link.name}
                href={link.href}
                className="relative text-cream/70 hover:text-cream transition-colors duration-300 text-sm font-medium tracking-wide hover:-translate-y-px"
              >
                {link.name}
              </a>
            ) : (
              <Link
                key={link.name}
                to={link.href}
                className="relative text-cream/70 hover:text-cream transition-colors duration-300 text-sm font-medium tracking-wide"
              >
                {link.name}
              </Link>
            )
          ))}
        </div>

        <Link
          to="/contact"
          className="hidden md:flex items-center gap-2 bg-cream/8 backdrop-blur-md border border-cream/15 text-cream px-6 py-2.5 rounded-full text-sm font-medium group overflow-hidden relative hover:border-primary/30 transition-colors"
        >
          <span className="relative z-10">Get in touch</span>
          <span className="relative z-10 text-base leading-none group-hover:translate-x-1 transition-transform duration-300">→</span>
        </Link>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-cream p-2 transition-transform active:scale-95"
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
        >
          <span className="block w-6 text-2xl leading-none" aria-hidden>{isOpen ? "×" : "☰"}</span>
        </button>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 p-6 m-4 rounded-2xl glass-card border border-cream/5 animate-fade-in">
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={() => setIsOpen(false)}
                className="text-cream/70 hover:text-cream transition-colors duration-300 text-lg font-medium py-2 hover:translate-x-2"
              >
                {link.name}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setIsOpen(false)}
              className="btn-primary text-center mt-4"
            >
              Get in touch
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
